import DOMPurify from 'isomorphic-dompurify'
import { escapeHtml } from './string-utils'
import type { HtmlString } from './type-utils'

export const extractVisibleTextFromHtml = (html: string | HtmlString | null | undefined): string => {
  const fragment = DOMPurify.sanitize(((html ?? '') as string).replace(/<br\s*\/?>|<\/p>|<\/div>/gi, ' '), {
    RETURN_DOM_FRAGMENT: true,
  })
  return (fragment.textContent ?? '').replace(/\s+/g, ' ').trim()
}

export const hasVisibleHtmlText = (html: string | HtmlString | null | undefined): boolean =>
  extractVisibleTextFromHtml(html)
    .replace(/\p{Default_Ignorable_Code_Point}/gu, '')
    .trim().length > 0

export const plainTextToHtml = (text: string | null | undefined): HtmlString =>
  escapeHtml(text).replace(/\r?\n/g, '<br />') as HtmlString

export const richTextForEditing = (
  html: string | HtmlString | null | undefined,
  plain: string | null | undefined,
): HtmlString => {
  if (hasVisibleHtmlText(html)) return html as HtmlString
  return plainTextToHtml(plain)
}
